import React from 'react';
import { Flex } from 'antd';

import { useDevExTheme } from 'jf/common/themes/DevExTheme';
import { DevExDrawer } from 'jf/components/DevExDrawer';
import { useTargetingClient } from 'jf/services/useTargetingClient';
import { useClientFlags } from 'jf/utils/useClientFlags';

import { ManageMSTeamsRespondentsCard } from './msteams/ManageMSTeamsRespondentsCard';
import { ManageCloseDateCard } from './ManageCloseDateCard';
import { ManageRemindersCard } from './ManageRemindersCard';
import { ManageRespondentsCard } from './ManageRespondentsCard';

const DRAWER_WIDTH = 640;

export const ManageSurveyDrawer: React.FC<{
  open: boolean;
  onClose: () => void;
  studyRef: string;
}> = (props) => {
  const theme = useDevExTheme();
  const flags = useClientFlags();

  const { useGetStudyTargets } = useTargetingClient();
  const { data: targets } = useGetStudyTargets({
    studyRef: props.studyRef,
    isEnabled: flags.slackTargeting, // EMP customers only
  });
  const messengerTargetingEnabled = !!targets?.length;

  return (
    <DevExDrawer
      title="Manage Survey"
      open={props.open}
      onClose={() => props.onClose()}
      width={DRAWER_WIDTH}
      closable
    >
      <Flex gap={theme.variable.spacing.lg} vertical>
        {flags.msTeamsTargeting && flags.slackTargeting ? ( // EMP customers with MST enabled
          <ManageMSTeamsRespondentsCard studyRef={props.studyRef} />
        ) : (
          <ManageRespondentsCard studyRef={props.studyRef} />
        )}
        {messengerTargetingEnabled && (
          <ManageRemindersCard studyRef={props.studyRef} onClose={props.onClose} />
        )}
        <ManageCloseDateCard studyRef={props.studyRef} />
      </Flex>
    </DevExDrawer>
  );
};
